<div class="about_us_wrap">
    <div class="our_mission_sections">
        <div class="our_mission_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="mission_content">
                        <h1>よくあるご質問</h1>
                        <span>Trinka（トリンカ）についてよくいただくご質問と回答を<br>まとめました</span>
                        <!-- <a href="https://demo.trinka.ai/" target="_blank">Try it Now</a> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="verticalTabSection">
    <div class="container">
        <div class="row">
            <div class="col-md-4">
                <div class="questionSections">
                    <ul class="nav nav-tabs">
                        <li (click)="gotoTop()"><a class="active" href="#TrinkaTabs" data-toggle="tab"><span class="OpenSansFonts"><span class="OpenSansFonts">Trinka</span>について</span></a></li>
                        <li (click)="gotoTop()"><a href="#AccountTabs" data-toggle="tab">アカウントについて</a></li>
                        <li (click)="gotoTop()"><a href="#AccountPaymentsTabs" data-toggle="tab">お支払いについて</a></li>
                        <li (click)="gotoTop()"><a href="#PlansTabs" data-toggle="tab">プランについて</a></li>
                        <li (click)="gotoTop()"><a href="#GeneralTabs" data-toggle="tab">その他のご質問</a></li>
                        <li (click)="gotoTop()"><a href="#SecurityTab" data-toggle="tab">セキュリティについて</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-md-8">
                <div class="answersSections">
                    <div class="tab-content">
                        <div class="tab-pane active" id="TrinkaTabs">
                            <div class="accordion" id="TrinkaTabsQuestion">
                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionOneContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionOneContent"><span class="OpenSansFonts">Trinka</span>とは何ですか？</a>
                                    </div>

                                    <div id="TrinkaQuestionOneContent" class="collapse show"
                                        aria-labelledby="TrinkaQuestionOne" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p><span class="OpenSansFonts">Trinka</span>（トリンカ）は、英文の文法、スペル、スタイル、用語統一などのミスをチェックし修正案を提示する、AI搭載の英語文章校正ツールです。ミスの修正の他、アカデミックライティングに適したトーンやスタイルの改善も提案します。<br>
                                                偏った表現・デリケートな表現についてのチェックもでき、簡潔な文章を書くためのヒントも提案。Trinkaの提案に沿って文章を修正するだけで、冗長な表現を減らし、専門分野に合ったフレーズや用語を使った学術的な文章を簡単に作成いただくことができます。さらに、原稿が学術論文として出版できるレベルかどうかをチェックする機能もあります。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionTwoContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionTwoContent"><span class="OpenSansFonts">Trinka</span>と、他のオンライン英文校正ツールとの違いは何ですか？</a>
                                    </div>

                                    <div id="TrinkaQuestionTwoContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionTwo" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>一般的な英文用の<a [routerLink]="['/grammar-checker']" class="text-link">文法チェッカー</a>はいくつもありますが、学術英語のライティングに特化し、各学術分野の専門用語や慣習に沿った表現や、論文としての出版適性をチェックできる<a [routerLink]="['/grammar-checker']" class="text-link">文法チェッカー</a>はほとんどありません。Trinka（トリンカ）は、アカデミックな文章を英語で作成する研究者・ライターの皆様のために開発されました。<br>
                                                Trinkaの正確性が高く、ライティングに関する幅広い問題に対応でき、学術ライティングにおいて優れた効果をもたらす英文校正ツールであることを比較検証した解説資料をご用意しています。<a
                                                [routerLink]="['/trinka-vs-grammarly-vs-language-tool']"
                                                target="_blank">こちら</a>からご覧ください。 
                                              </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionThreeContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionThreeContent"><span class="OpenSansFonts">Trinka</span>は、どのように英文をチェックするのでしょうか？</a>
                                    </div>

                                    <div id="TrinkaQuestionThreeContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionThree" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p><span class="OpenSansFonts">Trinka</span>（トリンカ）の英文チェック機能をつかさどる人工知能（AI）は、幅広い学術専門分野の数百万以上の原稿を通じて学習し、定期的に更新され続けています。そして厳密なテストを経た自然言語処理（NLP）のアルゴリズムによって稼働しています。
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionFour">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionFourContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionFourContent"><span class="OpenSansFonts">Trinka</span>の文法チェッカーの精度はどの程度でしょうか？</a>
                                    </div>

                                    <div id="TrinkaQuestionFourContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionFour" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p><span class="OpenSansFonts">Trinka</span>（トリンカ）は学術的な文書に特化した英文校正ツールで、学術英語、アカデミックライティング、テクニカルライティングを非常に高い精度でチェックします。<br>
                                                    当社が定期的に行う検証では、通常、90%以上の適合率と80%以上の再現率を達成します。これは機械学習（AI機能の一部）の評価指標値としては非常に高く、学術的/技術的な内容の校正で精度の高い結果を出せることを示しています。結果は対象英文の分野によって異なりますが、ユーザーの皆様からのフィードバックを受けながら、Trinkaの精度は向上し続けています。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionFive">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionFiveContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionFiveContent"><span class="OpenSansFonts">Trinka</span>は無料で利用できますか？</a>
                                    </div>

                                    <div id="TrinkaQuestionFiveContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionFive" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p><span class="OpenSansFonts">Trinka</span>（トリンカ）のベーシックプランは完全に無料でご利用いただけます。ただしベーシックプランでご利用いただける機能や単語数には制限があります。詳しくは<a  [routerLink]="['/pricing']" class="text-link" target="_blank">料金プランのページ</a>をご参照ください。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionSix">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionSixContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionSixContent"><span class="OpenSansFonts">Trinka</span>ではテクニカルライティングを改善できますか？</a>
                                    </div>

                                    <div id="TrinkaQuestionSixContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionSix" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>はい、可能です。<span class="OpenSansFonts">Trinka</span>（トリンカ）では、3000以上の複雑な文法ミスのチェックに加えて、文章のトーンとスタイルを改善し、APAスタイルやAMAスタイルのスタイルガイドに沿ったフォーマット調整も行います。幅広い専門分野に対応しており、各種テクニカルライティングのチェックにもお役立ていただけます。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionSeven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionSevenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionSevenContent"><span class="OpenSansFonts">Trinka</span>があれば、プロによる校正・校閲を受ける必要はありませんか？</a>
                                    </div>

                                    <div id="TrinkaQuestionSevenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionSeven" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>原稿の文章の質にもよります。英語が母語でない人の原稿で、論理構成に関わるミスが散見するようなものの場合は、専門家の校正者による校正のご利用をお勧めします。<br>
                                                <span class="OpenSansFonts">Trinka</span>（トリンカ）では、数千種類の文法ミスやその他の問題点を修正することはできますが、AIには限界があります。英文全体の論理の欠如や、文章の論理的構造の欠陥は、指摘できないのです。
                                                    英文執筆にすでにある程度の経験をお持ちで、論理的に正しい構成の文章を書く英語力をお持ちの場合は、文章のトーンや、言葉の選択、文法構造、スペルなどの問題をTrinkaで解決していただけるでしょう。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionEight">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionEightContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionEightContent"><span class="OpenSansFonts">Trinka</span>で、学位論文もチェックもできますか？</a>
                                    </div>

                                    <div id="TrinkaQuestionEightContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionEight" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>はい、<span class="OpenSansFonts">Trinka</span>（トリンカ）はあらゆる形式の学術文書、技術文書に適しています。卒論、研究論文、レポート、エッセイなどの英文のブラッシュアップにぜひご利用ください。</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="TrinkaQuestionNine">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionNineContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionNineContent">Can Trinka check a PDF for grammar and or spelling issues? </a>
                                    </div>
    
                                    <div id="TrinkaQuestionNineContent" class="collapse" aria-labelledby="TrinkaQuestionNine"
                                        data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Currently, Trinka supports MS Word files (doc/docx). We will add support for pdf and LaTeX files soon. </p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionTen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionTenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionTenContent"><span class="OpenSansFonts">Trinka</span>はPDFファイルの文法・スペルチェックもできますか？</a>
                                    </div>

                                    <div id="TrinkaQuestionTenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionTen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>現在、<span class="OpenSansFonts">Trinka</span>（トリンカ）はMS Wordファイル（doc/docx）のみをサポートしています。今後、PDFやLaTeXファイルのサポートを追加する予定です。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestioneleven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelevenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelevenContent">正しく書いている単語が<span class="OpenSansFonts">Trinka</span>にスペルミスと指摘された場合、どうすればよいですか？</a>
                                    </div>

                                    <div id="TrinkaQuestionelevenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestioneleven" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p><span class="OpenSansFonts">Trinka</span>（トリンカ）のAIは、何百万もの英語学術文献から学習を続けていますが、新しい単語に出会うこともあります。もし、正しいスペルの単語がスペルミスと指摘された場合は、その単語をTrinkaのマイ・ディクショナリーに追加してください。マイ・ディクショナリーに用語を追加すれば、Trinkaがそれをスペルミスと判断することはなくなります。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwelve">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwelveContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwelveContent"><span class="OpenSansFonts">Trinka</span>を利用して作成した論文は盗用あるいは剽窃とみなされますか？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwelveContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwelve" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Trinkaは、英語文書の言語面の問題を排除し、ライティングを改善するためのAI英文校正ツールです。盗用・剽窃とは、出典を正しく引用せずに、すでに誰かによって発表されたテキストを使用することです。Trinkaを使用することで剽窃が発生することはありませんが、誤って盗用・剽窃と疑われるような記述をしていないか確認するために、文書を盗用・剽窃チェックにかけることをお勧めします。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelThirteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelThirteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelThirteenContent"><span class="OpenSansFonts">Trinka</span>で、APAスタイルでのフォーマット調整は可能ですか？</a>
                                    </div>

                                    <div id="TrinkaQuestionelThirteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelThirteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>はい、<span class="OpenSansFonts">Trinka</span>（トリンカ）に搭載されているAPAスタイルガイドオプションを使用すれば、APAの言語/ライティング設定をすべて適用することができます。ただし、ページの余白、ナンバリング、見出しスタイルなどの設定は適用されません。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelFourteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelFourteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelFourteenContent"><span class="OpenSansFonts">Trinka</span>では英語以外の校正も行えますか？</a>
                                    </div>

                                    <div id="TrinkaQuestionelFourteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelFourteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>いいえ、<span class="OpenSansFonts">Trinka</span>（トリンカ）では英語の校正のみ可能です。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelFiveteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelFiveteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelFiveteenContent">どの様なデバイスで<span class="OpenSansFonts">Trinka</span>にアクセスできますか？</a>
                                    </div>

                                    <div id="TrinkaQuestionelFiveteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelFiveteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>コンピュータ（<span class="OpenSansFonts">PC、Mac、Chromebook</span>）、タブレット（<span class="OpenSansFonts">iPad、Android、Windows</span>）、モバイルデバイス（<span class="OpenSansFonts">iOS、Android、</span>その他のOS）等、最新のWebブラウザをサポートするデバイスであればTrinkaのサイトにアクセスできます。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelSixteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelSixteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelSixteenContent"><span class="OpenSansFonts">Trinka</span>のAPIは利用可能でしょうか？</a>
                                    </div>

                                    <div id="TrinkaQuestionelSixteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelSixteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>はい。<span class="OpenSansFonts">Trinka</span>（トリンカ）では、高い信頼性とスケーラビリティを誇るAPIの提供も行っており、様々なアプリケーションにも統合できます。詳しくは、<a  [routerLink]="['/enterprise']" target="_blank" class="text-link" class="OpenSansFonts">Trinka Enterprise</a>のページからお問い合わせください。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelSeventeen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelSeventeenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelSeventeenContent">複数のデバイスから同時に<span class="OpenSansFonts">Trinka</span>の同じアカウントにアクセスできますか？</a>
                                    </div>

                                    <div id="TrinkaQuestionelSeventeenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelSeventeen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>はい、可能です。ただし、同一のファイルを複数のデバイスから同時に操作することはできず、1つのデバイス/ブラウザのみで編集が可能です。</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelEighteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelEighteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelEighteenContent">What is the maximum word count Trinka can check?</a>
                                    </div>
    
                                    <div id="TrinkaQuestionelEighteenContent" class="collapse" aria-labelledby="TrinkaQuestionelEighteen"
                                        data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p><span class="OpenSansFonts">Trinka</span> can check for language and grammar for up to 150 words on our demo tool, and this limit gets exceeded once you register for free.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelNineteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelNineteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelNineteenContent">Wordプラグインは、MS Wordのどのバージョンに対応していますか？</a>
                                    </div>

                                    <div id="TrinkaQuestionelNineteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelNineteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>Wordプラグインは、WindowsのMicrosoft Word 2010以降のバージョンに対応しています。詳細は<a [routerLink]="['/wordplugin']" class="text-link" target="_blank" class="OpenSansFonts">こちら</a>をご覧ください。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelEighteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelEighteenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelEighteenContent"><span class="OpenSansFonts">Trinka</span>は<span class="OpenSansFonts">Google Chrome</span>で使用できますか？</a>
                                    </div>

                                    <div id="TrinkaQuestionelEighteenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelEighteen" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>はい。<span class="OpenSansFonts">Trinka</span>（トリンカ）の<span class="OpenSansFonts">Google Chrome</span>のプラグインは<a [routerLink]="['/browser-plugin']" class="OpenSansFonts text-link" target="_blank">こちら</a>からインストールいただけます。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwoenty">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwoentyContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwoentyContent"><span class="OpenSansFonts">Trinka</span>はFirefoxで使用できますか？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwoentyContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwoenty" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>はい。<span class="OpenSansFonts">Trinka</span>（トリンカ）のFirefoxのプラグインは<a [routerLink]="['/browser-plugin']" target="_blank" class="OpenSansFonts text-link">こちら</a>からインストールいただけます。</p>
                                        </div>
                                    </div>
                                </div>
                               
                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyOneContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyOneContent"><span class="OpenSansFonts">Trinka</span>はEdgeで使用できますか？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyOneContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyOne" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>はい。<span class="OpenSansFonts">Trinka</span>（トリンカ）のEdgeのプラグインは<a [routerLink]="['/browser-plugin']" class="OpenSansFonts text-link">こちら</a>からインストールいただけます。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyTwoContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyTwoContent"><span class="OpenSansFonts">Trinka</span>のプラグインが特定のウェブサイトで利用できないのはなぜですか？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyTwoContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyTwo" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>ウェブサイトは構造やデザインが様々で、<span class="OpenSansFonts">Trinka</span>（トリンカ）のブラウザ拡張機能が文章を読む際に、サイトの構造が邪魔になることがあります。正しく動作しないサイトについては、フィードバックをお寄せください。また、ご不明点がございましたら、<a
                                                href="mailto:support@trinka.ai" class="OpenSansFonts">support@trinka.ai</a> までお問い合わせください。
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyThreeContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyThreeContent"><span class="OpenSansFonts">Trinka</span>はSNS上で使用できますか？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyThreeContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyThree" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>はい。ブラウザ上で利用できるSNSであれば、<span class="OpenSansFonts">Trinka</span>（トリンカ）の機能をお使いいただけるものがあります。現在、弊社で利用できることが確認できているのはTwitter、Instagram、Facebook、LinkedIn、Redditです。ブラウザのプラグインをインストールし、ブラウザ上でSNSをご利用いただけば<span class="OpenSansFonts">Trinka</span>の機能をお使いいただけます。<br>
                                                Google Chromeのプラグインは<a [routerLink]="['/browser-plugin']" class="OpenSansFonts text-link" target="_blank" >こちら</a>から、Firefoxのプラグインは<a  [routerLink]="['/browser-plugin']" target="_blank" class="OpenSansFonts">こちら</a>からインストールいただけます。
                                              </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentySix">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentySixContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentySixContent"><span class="OpenSansFonts">Trinka</span>はLaTeXでも使えますか？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentySixContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentySix" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>現在、<span class="OpenSansFonts">Trinka</span>（トリンカ）はLaTeXファイルをサポートしていません。今後サポート機能を追加する予定です。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentySeven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentySevenContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentySevenContent"><span class="OpenSansFonts">Trinka</span>で、2つ以上の修正箇所が表示されましたが、1つを修正すると他の修正箇所が消えてしまいました。なぜですか？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentySevenContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentySeven" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>1箇所目の修正で2箇所目の修正（または他の修正）の必要がなくなっている可能性もあります。なお、ユーザーが提案を受け入れて文章を修正した後、<span class="OpenSansFonts">Trinka</span>（トリンカ）は修正後の文章も再度チェックします。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionEight">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionEightContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionEightContent"><span class="OpenSansFonts">Trinka</span>の「Writing Adviser」による提案はどのようなもので、「Enhancements」による提案とはどう違いますか？</a>
                                    </div>

                                    <div id="GenernalQuestionEightContent" class="collapse"
                                        aria-labelledby="GenernalQuestionEight" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p><span class="OpenSansFonts">Trinka</span>（トリンカ）のダッシュボードに表示されるAlertsの内、「Writing Adviser」は、英文を学術的なトーンの文体にするためのアドバイスを表示する機能で、学術的な英文の言葉遣いや慣習に合わせたライティングをサポートします。各種の表現や修飾語、能動態に変更可能な受動態の文章、文章全体の質などへのフィードバックをコメント形式で表示します。<br>
                                                    一方、「Enhancements」では、文法的に問題はないが改良の余地がある部分を対象とした改善案を提案します。例えば、簡潔な言葉を使って語数を減らす、偏った表現や微妙な表現を和らげる、長く複雑な言葉の代わりにシンプルな言葉を使う、などです。</p>
                                        </div>
                                    </div>
                                </div>




                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyEight">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyEightContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyEightContent"><span class="OpenSansFonts">Trinka</span>はインターネットに接続していなくても利用できますか？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyEightContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyEight" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>いいえ、<span class="OpenSansFonts">Trinka</span>（トリンカ）はインターネットに接続されていなければ、テキストをチェックすることはできません。
                                                    ただし、MS Wordファイルをアップロードしてファイル自動校正を行った上で、変更履歴付きファイルをダウンロードいただければ、インターネットに接続していなくても変更点をご確認いただけます。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionelTwentyNine">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionelTwentyNineContent" aria-expanded="true"
                                            aria-controls="TrinkaQuestionelTwentyNineContent"><span class="OpenSansFonts">Trinka</span>でチェックできるファイル形式には何がありますか？</a>
                                    </div>

                                    <div id="TrinkaQuestionelTwentyNineContent" class="collapse"
                                        aria-labelledby="TrinkaQuestionelTwentyNine" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>現在、MS Wordファイル（doc/docx）、txtファイル、rtfファイルをサポートしています。今後、PDFファイルとLaTeXファイルのサポートを追加する予定です。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="TrinkaQuestionel30">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#TrinkaQuestionel30Content" aria-expanded="true"
                                            aria-controls="TrinkaQuestionel30Content">Trinkaの盗用・剽窃チェックは他のツールと比べ、どう優れていますか？</a>
                                    </div>

                                    <div id="TrinkaQuestionel30Content" class="collapse"
                                        aria-labelledby="TrinkaQuestionel30" data-parent="#TrinkaTabsQuestion">
                                        <div class="card-body">
                                            <p>他のツールとは異なり、Trinkaでは参照するデータベースを、インターネットコンテンツのみや、インターネットと有料出版物との両方など、お客様のニーズに合わせて選択することができます。iThenとの提携によって実現したTrinkaの優れた検出テクノロジーは、世界の大手学術出版社から信頼いただいています。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane" id="AccountPaymentsTabs">
                            <div class="accordion" id="APTabsQuestion">
                                <div class="card">
                                    <div class="card-header" id="APQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#APQuestionOneContent" aria-expanded="true"
                                            aria-controls="APQuestionOneContent">クレジットカードでの支払いが通らなかったのですが。</a>
                                    </div>

                                    <div id="APQuestionOneContent" class="collapse show" aria-labelledby="APQuestionOne"
                                        data-parent="#APTabsQuestion">
                                        <div class="card-body">
                                            <p>様々な原因が考えられます。
                                                    例えば、</p>
                                            <ol>
                                                <li>お使いのクレジットカードが国際取引に対応していない</li>
                                                <li>入力情報に誤りがある</li>
                                                <li>ご利用限度額を超えている</li>
                                            </ol>
                                            <p>などが考えられますが、詳細を当社でお調べすることはできませんので、お手数ですがカード会社までお問い合わせください。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="APQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#APQuestionTwoContent" aria-expanded="true"
                                            aria-controls="APQuestionTwoContent">プレミアムプラン購入の支払い方法を教えてください。</a>
                                    </div>

                                    <div id="APQuestionTwoContent" class="collapse" aria-labelledby="APQuestionTwo"
                                        data-parent="#APTabsQuestion">
                                        <div class="card-body">
                                            <p>現在、クレジットカードでのみお支払いを受け付けています。国際的な取引が可能なクレジットカードであればお使いいただけます。もし、お支払い方法についてご質問等ございましたら、<a
                                                href="mailto:support@trinka.ai" class="OpenSansFonts">support@trinka.ai</a> までご連絡ください。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionThreeContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionThreeContent">クーポンコードはどこに入力すればよいですか？</a>
                                    </div>

                                    <div id="GenernalQuestionThreeContent" class="collapse"
                                        aria-labelledby="GenernalQuestionThree" data-parent="#APTabsQuestion">
                                        <div class="card-body">
                                            <p>現時点では、割引が適用されるお客様には専用のお支払いリンクをお送りしています。今後、お支払い画面に割引コード入力欄を追加する予定です。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane" id="AccountTabs">
                            <div class="accordion" id="AccountQuestions">
                                <div class="card">
                                    <div class="card-header" id="AccountQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#AccountQuestionOneContent" aria-expanded="true"
                                            aria-controls="AccountQuestionOneContent">プレミアムプランを購入したにも関わらず、<span class="OpenSansFonts">Trinka</span>のブラウザプラグインで、認識されません。</a>
                                    </div>

                                    <div id="AccountQuestionOneContent" class="collapse show"
                                        aria-labelledby="AccountQuestionOne" data-parent="#AccountQuestions">
                                        <div class="card-body">
                                            <p>ブラウザのプラグインをインストールした後、まず、そのプラグインを使ってお客様の<span class="OpenSansFonts">Trinka</span>（トリンカ）のアカウントにログインしてください。<br>
                                                    ログインできない、あるいはログインしてもプレミアムプランのアカウントを認識しない場合は、お手数ですが、<a
                                                    href="mailto:support@trinka.ai" class="OpenSansFonts text-link">support@trinka.ai</a> までご連絡ください。
                                             </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="AccountQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#AccountQuestionTwoContent" aria-expanded="true"
                                            aria-controls="AccountQuestionTwoContent">中途解約し、返金をしていただきたいのですが。</a>
                                    </div>

                                    <div id="AccountQuestionTwoContent" class="collapse"
                                        aria-labelledby="AccountQuestionTwo" data-parent="#AccountQuestions">
                                        <div class="card-body">
                                            <p>ご購入済みのプランの料金の払い戻しは行っておりません。自動更新をキャンセルするには、<a
                                                href="mailto:support@trinka.ai" class="OpenSansFonts text-link">support@trinka.ai</a> までご連絡ください。</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="AccountQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#AccountQuestionThreeContent" aria-expanded="true"
                                            aria-controls="AccountQuestionThreeContent">I am unable to receive
                                            verification email</a>
                                    </div>

                                    <div id="AccountQuestionThreeContent" class="collapse"
                                        aria-labelledby="AccountQuestionThree" data-parent="#AccountQuestions">
                                        <div class="card-body">
                                            <p>Please check the spam folder for the verification mail. If you still are
                                                unable to find the verification mail, then please contact our support on
                                                <a href="mailto:support@trinka.ai" class="OpenSansFonts">support@trinka.ai</a> and we will be
                                                glad to assist you.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="AccountQuestionFoure">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#AccountQuestionFoureContent" aria-expanded="true"
                                            aria-controls="AccountQuestionFoureContent">アカウントを消去したい場合どうすればよいですか？</a>
                                    </div>

                                    <div id="AccountQuestionFoureContent" class="collapse"
                                        aria-labelledby="AccountQuestionFoure" data-parent="#AccountQuestions">
                                        <div class="card-body">
                                            <p><a href="mailto:support@trinka.ai" class="OpenSansFonts text-link">support@trinka.ai</a>まで、メールにてお知らせください。</p>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <div class="tab-pane" id="PlansTabs">
                            <div class="accordion" id="PlansTabsQuestion">
                                <div class="card">
                                    <div class="card-header" id="PlanQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#PlanQuestionOneContent" aria-expanded="true"
                                            aria-controls="PlanQuestionOneContent">プレミアムプランの契約は自動更新されるのですか？</a>
                                    </div>

                                    <div id="PlanQuestionOneContent" class="collapse show"
                                        aria-labelledby="PlanQuestionOne" data-parent="#PlansTabsQuestion">
                                        <div class="card-body">
                                            <p class="mb-2">はい、プレミアムプランの契約は自動更新されます。自動更新のキャンセルをご希望の場合は、以下の手順で行ってください。</p>
                                            <ul>
                                                <li>Trinkaのアカウントに<a href="https://cloud.trinka.ai/signin?_rg=JP" class="hyperLink text-link" target="_blank">ログイン</a></li>
                                                <li>ダッシュボードの右上にある 「Account Settings」をクリック</li>
                                                <li>「Cancel subscription renewal」のリンクをクリック</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="PlanQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#PlanQuestionTwoContent" aria-expanded="true"
                                            aria-controls="PlanQuestionTwoContent">Can I get a student discount?</a>
                                    </div>

                                    <div id="PlanQuestionTwoContent" class="collapse" aria-labelledby="PlanQuestionTwo"
                                        data-parent="#PlansTabsQuestion">
                                        <div class="card-body">
                                            <p>Yes, student discounts are available. Write to us at <a
                                                    href="mailto:sales@trinka.ai">sales@trinka.ai</a> to know more and
                                                get your student discount.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="PlanQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#PlanQuestionThreeContent" aria-expanded="true"
                                            aria-controls="PlanQuestionThreeContent">購入したプランをアップグレードしたいのですが。</a>
                                    </div>

                                    <div id="PlanQuestionThreeContent" class="collapse"
                                        aria-labelledby="PlanQuestionThree" data-parent="#PlansTabsQuestion">
                                        <div class="card-body">
                                            <p><span class="OpenSansFonts">Trinka</span>（トリンカ）のダッシュボード右上にある「Upgrade」からアップグレードいただけます。もしできない場合は、お手数ですが<a
                                                href="mailto:support@trinka.ai" class="OpenSansFonts text-link">support@trinka.ai</a>までご連絡ください。
                                               </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="PlanQuestionFour">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#PlanQuestionFourContent" aria-expanded="true"
                                            aria-controls="PlanQuestionFourContent">グループでの購入、一括購入などでの割引はありますか？</a>
                                    </div>

                                    <div id="PlanQuestionFourContent" class="collapse"
                                        aria-labelledby="PlanQuestionFour" data-parent="#PlansTabsQuestion">
                                        <div class="card-body">
                                            <p>はい。チームライセンスもご用意しており、規模に応じて割引が適用されます。お客様それぞれの状況に応じてお見積もりいたしますので、<a
                                                href="mailto:sales@trinka.ai" class="text-link">sales@trinka.ai</a> までお問い合わせください。</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="tab-pane" id="GeneralTabs">
                            <div class="accordion" id="GeneralTabsQuestion">
                                <!-- <div class="card">
                                    <div class="card-header" id="GeneralQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GeneralQuestionOneContent" aria-expanded="true"
                                            aria-controls="GeneralQuestionOneContent">How to enable grammar checker in
                                            MS Word?</a>
                                    </div>

                                    <div id="GeneralQuestionOneContent" class="collapse show"
                                        aria-labelledby="GeneralQuestionOne" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>Once you have installed Trinka MS Word Add-in, open any document in MS Word, look out for Trinka in the toolbar, and click
                                                to open it. Log in using your Trinka credentials if prompted. Once you
                                                are logged in, you should see the Trinka toolbar, and it should also
                                                start displaying the suggestions.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="GeneralQuestionTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GeneralQuestionTwoContent" aria-expanded="true"
                                            aria-controls="GeneralQuestionTwoContent"><span class="OpenSansFonts">Trinka</span>を使うために、文法チェッカーのソフトウェアなどをダウンロードする必要がありますか？</a>
                                    </div>

                                    <div id="GeneralQuestionTwoContent" class="collapse show"
                                        aria-labelledby="GeneralQuestionTwo" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>いいえ、<span class="OpenSansFonts">Trinka</span>（トリンカ）を使うにあたり、ソフトウェアをダウンロードいただく必要はありません。ブラウザからログインするだけでご利用いただけます。<br>ただし、Microsoft Wordで<span class="OpenSansFonts">Trinka</span>を使用するには、MS Wordプラグイン（近日公開予定）をインストールしていただく必要があります。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GeneralQuestionThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GeneralQuestionThreeContent" aria-expanded="true"
                                            aria-controls="GeneralQuestionThreeContent"><span class="OpenSansFonts">Trinka</span>の「Spelling」による提案はどのようなものですか？</a>
                                    </div>

                                    <div id="GeneralQuestionThreeContent" class="collapse"
                                        aria-labelledby="GeneralQuestionThree" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p><span class="OpenSansFonts">Trinka</span>（トリンカ）のダッシュボードに表示されるAlertsの内、「Spelling」は、文脈に即したスペルチェックを行い、単体では正しい綴りでも文脈上正しい綴りではない単語を識別し、修正案を提示します。例えば、"site"という単語を、文脈によって"sight"という単語に修正しなければならない場合などです。通常のスペルチェッカーでは、このようなミスは検出できません。
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionFoure">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionFoureContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionFoureContent">テクニカルライティングは通常のライティングとどう違うのでしょうか？</a>
                                    </div>

                                    <div id="GenernalQuestionFoureContent" class="collapse"
                                        aria-labelledby="GenernalQuestionFoure" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>一般的なライティングもテクニカルライティングも、英語の文法、スペル、句読点などのルールは同じです。しかし、テクニカルライティングには、プロフェッショナルなトーンとスタイルがあり、様々なファクトや統計などの詳細な情報が含まれます。テクニカルライティングには、客観的な記述が必要とされます。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionFive">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionFiveContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionFiveContent">テクニカルライティングと学術的なライティングの違いは何ですか？</a>
                                    </div>

                                    <div id="GenernalQuestionFiveContent" class="collapse"
                                        aria-labelledby="GenernalQuestionFive" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>テクニカルライティングは、サービスや製品についての、詳細で明確な情報を提供することが主な目的です。論文など、学術的なライティングでは、特定のテーマについての理論や視点の証明に重きが置かれます。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionSix">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionSixContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionSixContent"><span class="OpenSansFonts">Trinka</span>はMacでも使用できますか？</a>
                                    </div>

                                    <div id="GenernalQuestionSixContent" class="collapse"
                                        aria-labelledby="GenernalQuestionSix" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p><span class="OpenSansFonts">Trinka</span> （トリンカ）のホームページやダッシュボードには、すべてのOSからアクセスできます。さらに、今後、 Microsoft WordのプラグインをWindows版とMac版の両方でリリースする予定です。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionSeven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionSevenContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionSevenContent">アフィリエイトプログラムはありますか？</a>
                                    </div>

                                    <div id="GenernalQuestionSevenContent" class="collapse"
                                        aria-labelledby="GenernalQuestionSeven" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>ございます。アフィリエイトプログラムでは、<span class="OpenSansFonts">Trinka</span>（トリンカ）のサイトをご紹介いただいたお客様に報酬をお支払いしています。参加方法は簡単で料金も掛かりません。詳細は<a [routerLink]="['/affiliates']" target="_blank" class="text-link">こちら</a>をご覧ください</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card">
                                    <div class="card-header" id="GenernalQuestionEight">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionEightContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionEightContent">What does Writing Adviser do
                                            and how is it different from Enhancements?</a>
                                    </div>

                                    <div id="GenernalQuestionEightContent" class="collapse"
                                        aria-labelledby="GenernalQuestionEight" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p>Writing Adviser is designed for writers who wish to employ an academic
                                                tone in their texts. These features are unique to academic English
                                                writing and scientific convention. It provides feedback on hedge or
                                                booster words, weak modifiers, passive voice sentences that can be
                                                changed to the active voice, and the overall quality of sentences.
                                                Enhancements cover only those aspects of writing which are grammatically
                                                sound but have scope for further improvement and polishing, e.g.,
                                                reducing the word count employing concise words, neutralizing biased or
                                                sensitive language, or using simpler words in place of longer, complex
                                                ones.</p>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="card">
                                    <div class="card-header" id="GenernalQuestionNine">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#GenernalQuestionNineContent" aria-expanded="true"
                                            aria-controls="GenernalQuestionNineContent">問題が起きた際にはどこに連絡すればよいですか？</a>
                                    </div>

                                    <div id="GenernalQuestionNineContent" class="collapse"
                                        aria-labelledby="GenernalQuestionNine" data-parent="#GeneralTabsQuestion">
                                        <div class="card-body">
                                            <p><a
                                                    href="mailto:support@trinka.ai" class="OpenSansFonts text-link">support@trinka.ai</a>までご連絡ください。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>

                        <div class="tab-pane" id="SecurityTab">
                            <div class="accordion" id="SecurityTabQuestion">
                                <div class="card">
                                    <div class="card-header" id="SecurityQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#SecurityQuestionOneContent" aria-expanded="true"
                                            aria-controls="SecurityQuestionOneContent"><span class="OpenSansFonts">Trinka</span>側でユーザーのパスワードは見られますか？</a>
                                    </div>

                                    <div id="SecurityQuestionOneContent" class="collapse show"
                                        aria-labelledby="SecurityQuestionOne" data-parent="#SecurityTabQuestion">
                                        <div class="card-body">
                                            <p>いいえ、<span class="OpenSansFonts">Trinka</span>（トリンカ）の側ではパスワードやクレジットカード情報など、機密情報にアクセスすることはありません。</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="SecurityQuestionOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#SecurityQuestionOneContent" aria-expanded="true"
                                            aria-controls="SecurityQuestionOneContent">データは安全に管理されますか？</a>
                                    </div>

                                    <div id="SecurityQuestionOneContent" class="collapse"
                                        aria-labelledby="SecurityQuestionOne" data-parent="#SecurityTabQuestion">
                                        <div class="card-body">
                                            <p>当社ではプライバシーとデータセキュリティを最重視しており、データやファイルの転送には256ビットの暗号化を採用しています。また、世界的に認められているセキュリティ証明で、脅威を防ぐための最高の手段である高保証のSSL証明書も保持しています。当社ではお客様の個人情報を第三者と共有することはありません。ご心配な点や詳しい情報が必要な場合は、<a
                                                href="mailto:support@trinka.ai" class="OpenSansFonts text-link">support@trinka.ai</a> までご連絡ください。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="FAQFooterSection">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="FAQfooterText">
                    <h2>今すぐお試しください</h2>
                    <a href="https://cloud.trinka.ai/signup?_rg=JP&_ga=2.244105536.496124804.1628486552-354402315.1626066855-354402315" target="_blank">無料で登録する</a>
                </div>
            </div>
        </div>
    </div>
</div>

